export default __webpack_public_path__ + "static/media/bg_question.08012d06.png";